import { Directive, Input, TemplateRef, ViewContainerRef, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appLoadingComponent]',
})
export class LoadingComponentDirective {
    private hasView = false;

    @Input() set appLoadingComponent(isLoading: boolean) {
        this.vcr.clear(); // Limpia cualquier contenido anterior

        if (isLoading) {
            // Mostrar el spinner
            const spinnerTemplate = `
        <div class="spinner-container">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
          </div>
        </div>
      `;
            const element = document.createElement('div');
            element.innerHTML = spinnerTemplate;
            this.vcr.createEmbeddedView(this.templateRef, { element });
        } else {
            // Mostrar el contenido original
            this.vcr.createEmbeddedView(this.templateRef);
        }
    }

    constructor(private templateRef: TemplateRef<any>, private vcr: ViewContainerRef) {}
}
